module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAASFBMVEUAAAD////////////////////////////////////////////////////////////////////////////////////////////neHiwAAAAF3RSTlMA1U6tVwkI6lSvlY19X0ZDOffZ2NCGDmiq6hwAAACXSURBVDjLxZJJDsMgEAQrTgjBeMvK/38aZyQ0B6dtyRfPtQoY1E0T4w0xbUyBMo8wzjN6U8xQvGQGZRg/faAx4/KfB3BDcDcEXxjOryAMP78wBHdDcjecC6Ot+ynDuTI0h9H4EznZhDiAzt9/K/jjXg2RP5O4w/M5tB9hdz9S3X9nP0T+1RjZ6Ef6vfBa6UcPXYeaKfd8AfHvGXjoOne9AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/mobile/chahao.png
// module id = +Y4a
// module chunks = 1